export default class extends HTMLElement {
  connectedCallback () {
    this.button = document.getElementById(this.dataset.buttonId)

    if (this.button) {
      this.button.addEventListener('mouseenter', () => { this.init() })
      this.button.addEventListener('touchstart', () => { this.init() })
      this.button.addEventListener('click', () => { this.openChat() })
    }

    document.addEventListener('keydown', this.handleKeyDown)
  }

  handleKeyDown = (event) => {
    const isMac = (navigator.userAgentData?.platform || navigator.platform)?.toLowerCase()?.includes('mac')
    const isKShortcut = ((isMac && event.metaKey) || (!isMac && event.ctrlKey)) && event.key === 'k'
    const isSlashShortcut = event.key === '/'
    const activeTag = document.activeElement?.tagName?.toLowerCase()
    const isInputFocused = ['input', 'textarea', 'select', 'search-modal'].includes(activeTag)

    if (isKShortcut || (isSlashShortcut && !isInputFocused)) {
      event.preventDefault()

      this.open()
    }
  }

  async init () {
    this.appPromise ||= this.initApp()

    await this.appPromise
  }

  async initApp () {
    const [
      { createApp },
      { default: styles },
      { default: SearchModal }
    ] = await Promise.all([
      import(/* webpackChunkName: "search-modal" */ 'vue'),
      import(/* webpackChunkName: "search-modal" */ '../search/search.scss'),
      import(/* webpackChunkName: "search-modal" */ '../search/search_modal.vue')
    ])

    const shadow = this.attachShadow({ mode: 'open' })
    const style = document.createElement('style')

    style.textContent = styles[0][1].replace(/:root/g, ':host').replace(/html {/g, '.ds {')

    this.appElem = document.createElement('div')
    this.appElem.classList.add('ds')
    this.style.display = 'block'

    shadow.appendChild(style)

    this.app = createApp(SearchModal)
    this.vm = this.app.mount(this.appElem)

    if (this.button && this.dataset.hideButton !== 'false') {
      this.vm.$watch('isModalOpen', (value) => {
        this.button.classList.toggle('hidden', value)
      })
    }

    shadow.appendChild(this.appElem)
  }

  disconnectedCallback () {
    this.app?.unmount()
    this.appElem?.remove()

    document.removeEventListener('keydown', this.handleKeyDown)
  }

  async open () {
    await this.init()

    this.vm?.openModal()
  }

  async openChat () {
    await this.init()

    this.vm?.openChatModal()
  }
}
